import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import TrainerCard from './TrainerCard';

export default function Trainers() {

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const trainers = [
    { name: "Gungun", type: "inhouse", fullname: "Vichayut" },
    { name: "Benztr", type: "freelance", fullname: "kajonsak" },
    { name: "Eem", type: "freelance", fullname: "Wilawan" },
    { name: "Gym", type: "inhouse", fullname: "Vipoo" },
    { name: "Gook", type: "freelance", fullname: "Gook" }
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        p: 1,
        m: 1,
        flexWrap: 'wrap',
        bgcolor: "background.paper",
        borderRadius: 1,
      }}
    >ป
      {trainers.map((trainer) => (
        <Paper elevation={3} sx={{ m: 1 }}>
          <TrainerCard trainer={trainer} setOpen={setOpen} />
        </Paper>
      ))}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Disagree
          </Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}